import http from "../http-common";

class HomeRegulatoryExchangeService {
  getHomeRegulatoryExchange() {
    return http.get("/regulatory-exchange");
  }
}

export default new HomeRegulatoryExchangeService();
